import { Box, Typography, Paper, Skeleton } from '@mui/material';
import NoDataFallback from '../../common/NoDataFallback';

interface WebFormJsonProps {
  apiResponse?: any;
  isPending?: boolean;
}

const WebFormJson = ({ apiResponse, isPending }: WebFormJsonProps = {}) => {
  return (
    <Box sx={{ p: 1, backgroundColor: '#FFFFFF' }}>
      {/* API Response */}
      {isPending ? (
        <Paper
          elevation={0}
          sx={{
            p: 3,
            backgroundColor: '#F9FAFB',
            border: '1px solid #E5E7EB',
            borderRadius: 2,
          }}
        >
          <Typography fontWeight={500} mb={2}>
            Response Data:
          </Typography>
          <Box sx={{ pt: 1 }}>
            <Skeleton variant="rectangular" height={20} sx={{ mb: 1 }} />
            <Skeleton variant="rectangular" height={20} sx={{ mb: 1 }} />
            <Skeleton variant="rectangular" height={20} sx={{ mb: 1 }} />
            <Skeleton variant="rectangular" height={20} sx={{ mb: 1 }} />
            <Skeleton variant="rectangular" height={20} sx={{ mb: 1 }} />
          </Box>
        </Paper>
      ) : apiResponse === null || apiResponse === undefined ? (
        <NoDataFallback
          message="No response data available"
          description="Fill the preview form and submit to see the response here"
        />
      ) : (
        <Paper
          elevation={0}
          sx={{
            backgroundColor: '#FFFFFF',
            border: '3px solid #F3F5F8',
            borderRadius: '12px',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              backgroundColor: '#F9FAFB',
              width: '100%',
              height: 40,
              gap: '10px',
              padding: '12px 24px',
            }}
          >
            <Typography fontWeight={400} color="#6B6F80" fontSize={12}>
              API Response:
            </Typography>
          </Box>
          <Box
            component="pre"
            sx={{
              overflowX: 'auto',
              fontSize: '0.875rem',
              p: 2,
              backgroundColor: '#FFFFFF',
              borderRadius: 1,
            }}
          >
            {JSON.stringify(apiResponse, null, 2)}
          </Box>
        </Paper>
      )}
    </Box>
  );
};

export default WebFormJson;
